function capitalized(name) {
    const capitalizedFirst = name[0].toUpperCase();
    const rest = name.slice(1);
    return capitalizedFirst + rest;
}
function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}
export {capitalized, delay}